import React, { useEffect, useMemo, useRef, useState } from "react";
import { StepUpSpinner } from "../../../Components/Loader";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  InputAdornment,
  Paper,
} from "@mui/material";
import {
  useGetPositionQuery,
  useEmpPayrollPayrollRecordReportQuery,
  useGetTeamSerchOnlyQuery,
} from "../../../Api/attoDeskApi";
import {
  IEmployeePayroll,
  IPosition,
  IPayrollDateRangeList,
  IPayrollEachEmployeDateList,
  ITeam,
  IEmployeePunchRecord,
} from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, useParams } from "react-router-dom";
import useUser from "../../../Core/hook/useUser";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import "jspdf-autotable";
import { CiSearch } from "react-icons/ci";
import "jspdf-autotable";
import ReactToPrint from "react-to-print";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const { id: payrollId } = useParams<{ id: string }>();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const componentRef = useRef<HTMLDivElement>(null);
  const { userHasRight } = useUser();
  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);
  const [selectedEmpId, setSelectedEmpId] = useState<string>(" ");

  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | undefined>(
    undefined
  );
  const {
    data: tenantData,
    isLoading: tenantIsLoading,
    isError: tenantIsError,
    refetch: tenantRefetch,
  } = useGetTeamSerchOnlyQuery({
    searchText: searchQueryCustomer,
    id: "",
  });

  const { data, isLoading, isError, refetch } =
    useEmpPayrollPayrollRecordReportQuery({
      payrollId: String(payrollId),
      empid: selectedEmpId,
    });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const payrollSummaryDataList = useMemo(() => {
    return data?.recordDate as IPayrollDateRangeList;
  }, [data?.recordDate]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const teamList: ITeam[] = Array.isArray(tenantData?.data)
    ? (tenantData?.data as ITeam[])
    : [];

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const handleSelectCustomer = (team: ITeam) => {
    setSelectedEmpId(String(team.id));
    setSearchQueryCustomer(
      `${team.teamFirstName || ""} ${team.teamLastName || ""}`
    );
    setShowDropdownCustomer(false);
  };

  const handleFocusOrClickCustomer = () => {
    setShowDropdownCustomer(true);
    if (currentSearchQueryCustomer === "") {
      refetch();
    }
  };

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQueryCustomer(value);
    if (!value.trim()) {
      setSelectedEmpId("");
    }
  };
  useEffect(() => {
    if (payrollSummaryDataList?.startDate) {
      setSelectedStartDate(dayjs(payrollSummaryDataList.startDate));
    }
    if (payrollSummaryDataList?.endDate) {
      setSelectedEndDate(dayjs(payrollSummaryDataList.endDate));
    }
  }, [payrollSummaryDataList]);

  const project: IEmployeePayroll[] = useMemo(() => {
    if (tenantData && Array.isArray(tenantData.data)) {
      return tenantData.data as IEmployeePayroll[];
    }
    return [];
  }, [tenantData]);

  const employeeData = Array.isArray(data?.data) ? data?.data : [];

  const currentMonthDate = dayjs().format("YYYY MMM, DD");

  const exportToExcel = (
    employeeData: {
      employee: IEmployeePayroll;
      attendance: IEmployeePunchRecord[];
    }[]
  ) => {
    const wb = XLSX.utils.book_new();

    employeeData.forEach((record) => {
      const wsData = [
        ["Payroll Summary Report"],
        [
          "Period",
          `${
            selectedStartDate ? selectedStartDate.format("MMM-DD, YYYY") : ""
          } to ${
            selectedEndDate ? selectedEndDate.format("MMM-DD, YYYY") : ""
          }`,
        ],
        [],
        ["Employee Name", record.employee.employee_name],
        [
          "Position",
          postionMap.get(record.employee.employee_position_id) || "",
        ],
        [],
        [
          "Date",
          "Records",
          "Actual Hours",
          "Total Break Hours",
          "Total working hours",
          "Hourly Salary",
          "Total Amount",
        ],
      ];

      record.attendance.forEach((att: IEmployeePunchRecord) => {
        const Records =
          att.punchDetails.length > 0
            ? att.punchDetails
                .map((punchDetail) => {
                  const inTime = formatTime(punchDetail.punch_in_time);
                  const outTime = punchDetail.punch_out_time
                    ? punchDetail.punch_in_date !== punchDetail.punch_out_date
                      ? `${dayjs(punchDetail.punch_out_date).format(
                          "MMM-DD, YYYY"
                        )} ${formatTime(punchDetail.punch_out_time)}`
                      : formatTime(punchDetail.punch_out_time)
                    : "Pending";

                  return `${inTime} - ${outTime}`;
                })
                .join(", ")
            : "";

        const actualHours =
          att.break_hours === null ||
          att.total_hours === null ||
          isNaN(parseFloat(String(att.break_hours))) ||
          isNaN(parseFloat(String(att.total_hours)))
            ? ""
            : parseFloat(String(att.break_hours)) +
                parseFloat(String(att.total_hours)) ===
              0
            ? "-"
            : `${(
                parseFloat(String(att.break_hours)) +
                parseFloat(String(att.total_hours))
              ).toFixed(2)} hrs`;

        const totalBreakHours =
          att.break_hours === null || isNaN(parseFloat(String(att.break_hours)))
            ? ""
            : parseFloat(String(att.break_hours)) === 0
            ? "-"
            : `${parseFloat(String(att.break_hours)).toFixed(2)} hrs`;
        const totalWorkingHours =
          att.total_hours === null || isNaN(parseFloat(String(att.total_hours)))
            ? ""
            : parseFloat(String(att.total_hours)) === 0
            ? "-"
            : `${parseFloat(String(att.total_hours)).toFixed(2)} hrs`;
        const hourlySalary =
          record.employee.hourly_salary === null ||
          isNaN(parseFloat(String(record.employee.hourly_salary)))
            ? ""
            : parseFloat(String(record.employee.hourly_salary)) === 0
            ? "-"
            : `$ ${parseFloat(String(record.employee.hourly_salary)).toFixed(
                2
              )}`;
        const totalAmount = `$ ${(
          (Number(att.total_hours) || 0) *
          (Number(record.employee?.hourly_salary) || 0)
        ).toFixed(2)}`;
        wsData.push([
          dayjs(att.recordDate).format("YYYY-MM-DD"),
          Records,
          actualHours,
          totalBreakHours,
          totalWorkingHours,
          hourlySalary,
          totalAmount,
        ]);
      });

      const totalNormalHours = `${Number(
        record.employee.total_normal_hours || 0
      ).toFixed(2)} hrs`;

      const totalSalaryForEmp = `$ ${Number(
        Number(record.employee.total_normal_hours || 0) *
          Number(record.employee.hourly_salary || 0)
      ).toFixed(2)}`;

      const normalWorkingAmount = `$ ${Number(
        Number(record.employee.total_normal_hours || 0) *
          Number(record.employee.hourly_salary || 0)
      ).toFixed(2)}`;

      const oTAmountPush = `$ ${Number(
        Number(record.employee.total_ot_hours || 0) *
          Number(record.employee.ot_hourly_salary || 0)
      ).toFixed(2)}`;

      const adjustmentAmountPush = `$ ${Number(
        record.employee.bonus_amount || 0
      ).toFixed(2)}`;

      const totalAmountPush = `$ ${Number(
        record.employee.total_salary || 0
      ).toFixed(2)}`;

      wsData.push(
        ["", "", "", "", totalNormalHours, "", totalSalaryForEmp],
        [],
        [
          `Normal Working Amount (
          ${Number(record.employee.total_normal_hours || 0).toFixed(2)}
          ${" hrs * $"}
          ${Number(record.employee.hourly_salary || 0).toFixed(2)}
          )`,
          normalWorkingAmount,
        ],

        [
          `OT Amount (
            ${Number(record.employee.total_ot_hours || 0).toFixed(2)}
            ${" hrs * $"}
            ${Number(record.employee.ot_hourly_salary || 0).toFixed(2)}
            )`,
          oTAmountPush,
        ],

        [`Adjustment Amount`, adjustmentAmountPush],
        [`Total Amount`, totalAmountPush]
      );

      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, record.employee.employee_name);
    });

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const fileNameEx = `Payroll_Summary_Report ${
      selectedStartDate ? selectedStartDate.format("MMM-DD-YYYY") : ""
    } to ${selectedEndDate ? selectedEndDate.format("MMM-DD-YYYY") : ""}`;
    XLSX.writeFile(wb, `${fileNameEx}.xlsx`);
    // saveAs(
    //   new Blob([wbout], { type: "application/octet-stream" }),
    //   `${fileNameEx}.xlsx`
    // );
  };

  return (
    <div>
      <Card className={classes.quotesCardStaff}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2} alignItems="center" p={5}>
              <Grid item lg={2} md={12} sm={12} xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedStartDate}
                    readOnly
                    className={classes.searchTextField}
                    disabled
                    slotProps={{
                      textField: {
                        placeholder: "Start Date",
                        size: "small",
                        sx: {
                          width: "200px",
                        },
                        InputProps: {
                          sx: {
                            fontSize: 14,
                            border: "none",
                          },
                          classes: {
                            root: classes.textFieldQuote,
                            notchedOutline: classes.notchedOutline,
                          },
                        },
                        InputLabelProps: {
                          sx: {
                            fontSize: 14,
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item lg={2} md={12} sm={12} xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedEndDate}
                    readOnly
                    className={classes.searchTextField}
                    disabled
                    slotProps={{
                      textField: {
                        placeholder: "End Date",
                        size: "small",
                        sx: {
                          width: "200px",
                        },
                        InputProps: {
                          sx: {
                            fontSize: 14,
                            border: "none",
                          },
                          classes: {
                            root: classes.textFieldQuote,
                            notchedOutline: classes.notchedOutline,
                          },
                        },
                        InputLabelProps: {
                          sx: {
                            fontSize: 14,
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                item
                lg={8}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" sx={{ pr: 2 }}>
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        sx: {
                          fontSize: 14,
                          border: "none",
                        },
                        classes: {
                          root: classes.textFieldQuote,
                          notchedOutline: classes.notchedOutline,
                        },
                      }}
                      value={searchQueryCustomer}
                      onChange={handleTextFieldChange}
                      placeholder="Name & phone number .."
                      size="small"
                      onFocus={handleFocusOrClickCustomer}
                      onClick={handleFocusOrClickCustomer}
                      sx={{ flexGrow: 1, width: "100%" }}
                      className={classes.searchTextField}
                      InputLabelProps={{
                        sx: {
                          fontSize: 14,
                          border: "none",
                        },
                      }}
                    />
                    {showDropdownCustomer && (
                      <Paper className={classes.dropdownPaper}>
                        {tenantIsLoading ? (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "10px",
                            }}
                          >
                            <CircularProgress size={24} />
                          </div>
                        ) : (
                          teamList.length > 0 &&
                          teamList.map((team) => (
                            <MenuItem
                              key={team.id}
                              onClick={() => handleSelectCustomer(team)}
                            >
                              {`${team.teamFirstName || ""} ${
                                team.teamLastName || ""
                              }`}
                            </MenuItem>
                          ))
                        )}
                      </Paper>
                    )}
                  </Grid>
                  <Grid item>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          // variant="contained"
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButtonPdfExcel}
                        >
                          Print
                        </Button>
                      )}
                      content={() => componentRef.current}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      startIcon={<TableViewIcon />}
                      className={classes.addButtonPdfExcel}
                      onClick={() => exportToExcel(employeeData ?? [])}
                    >
                      Excel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div ref={componentRef}>
            <Grid item lg={12} md={12} sm={12} xs={12} mt={5}>
              <Grid container spacing={2}>
                <Grid item lg={4} md={6} sm={6} xs={6} mb={2}>
                  <Grid container px={4}>
                    <img
                      src={companyLogo}
                      alt="step"
                      style={{
                        width: "150px",
                        height: "70px",
                        display: "block",
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid item lg={8} md={6} sm={6} xs={6} mb={2}>
                  <Typography
                    variant="subtitle1"
                    textAlign={"right"}
                    className={classes.cardTitle256}
                    px={5}
                  >
                    Payroll Summary Report
                  </Typography>
                  <Typography variant="subtitle1" textAlign={"right"} px={5}>
                    {"Period: "}
                    {selectedStartDate
                      ? selectedStartDate.format("MMM-DD, YYYY")
                      : ""}
                    {" to "}{" "}
                    {selectedEndDate
                      ? selectedEndDate.format("MMM-DD, YYYY")
                      : ""}
                  </Typography>
                </Grid>
                {isLoading ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                  </Grid>
                ) : isError ? (
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    // sx={{ textAlign: "center" }}
                  >
                    {isError ? "Something went wrong" : "No data available"}
                  </Grid>
                ) : (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {employeeData?.map(
                      (
                        record: {
                          employee: IEmployeePayroll;
                          attendance: IEmployeePunchRecord[];
                        },
                        index
                      ) => {
                        let backgroundColor;
                        if (index % 2 === 0) {
                          // backgroundColor = "#f9fbff";
                          backgroundColor = "#ffffff";
                        } else if (index % 2 === 1) {
                          backgroundColor = "#ffffff";
                        } else {
                          backgroundColor = "#000000";
                        }
                        return (
                          <div
                            key={record.employee.id}
                            style={{
                              pageBreakAfter: "always",
                              backgroundColor: "#ffffff",
                              padding: "16px",
                              marginBottom: "16px",
                            }}
                          >
                            <Grid
                              container
                              spacing={2}
                              key={record.employee.id}
                              mb={5}
                              p={1}
                              pb={5}
                              sx={{
                                backgroundColor: backgroundColor,
                              }}
                            >
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography className={classes.h4} px={2}>
                                  {record.employee.employee_name}
                                </Typography>
                                <Typography variant="subtitle1" px={2}>
                                  {postionMap.get(
                                    record.employee.employee_position_id
                                  ) || ""}
                                </Typography>
                              </Grid>
                              {record.attendance.length > 0 && (
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <TableContainer sx={{ px: 2 }}>
                                    <Table className={classes.table}>
                                      <TableHead
                                        className={classes.tableHeaderRow}
                                      >
                                        <TableRow>
                                          <TableCell
                                            className={classes.tablheaderId}
                                          >
                                            <strong>Date</strong>
                                          </TableCell>
                                          <TableCell
                                            className={classes.tablheaderId}
                                            sx={{ textAlign: "left" }}
                                          >
                                            <strong>Records</strong>
                                          </TableCell>
                                          <TableCell
                                            className={classes.tablheaderId}
                                            sx={{ textAlign: "right" }}
                                          >
                                            <strong>Actual Hours</strong>
                                          </TableCell>
                                          <TableCell
                                            className={classes.tablheaderId}
                                            sx={{ textAlign: "right" }}
                                          >
                                            <strong>Total Break Hours</strong>
                                          </TableCell>

                                          <TableCell
                                            className={classes.tablheaderId}
                                            sx={{ textAlign: "right" }}
                                          >
                                            <strong>Total working hours</strong>
                                          </TableCell>

                                          <TableCell
                                            className={classes.tablheaderId}
                                            sx={{ textAlign: "right" }}
                                          >
                                            <strong>Hourly Salary</strong>
                                          </TableCell>

                                          <TableCell
                                            className={classes.tablheaderId}
                                            sx={{ textAlign: "right" }}
                                          >
                                            <strong>Total Amount</strong>
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {isLoading ? (
                                          <TableRow>
                                            <TableCell
                                              colSpan={20}
                                              align="center"
                                            >
                                              <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                                            </TableCell>
                                          </TableRow>
                                        ) : isError ||
                                          record.attendance.length === 0 ? (
                                          <TableRow>
                                            <TableCell
                                              colSpan={20}
                                              align="center"
                                            >
                                              {isError
                                                ? "Error fetching data"
                                                : "No data available"}
                                            </TableCell>
                                          </TableRow>
                                        ) : (
                                          record.attendance.map((att) => (
                                            <TableRow
                                              key={att.id}
                                              className={classes.tableRowHover}
                                            >
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                              >
                                                {dayjs(att.recordDate).format(
                                                  "YYYY-MM-DD"
                                                )}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                                sx={{ textAlign: "left" }}
                                              >
                                                {att.punchDetails.length > 0 ? (
                                                  att.punchDetails.map(
                                                    (punchDetail, index) => {
                                                      const punchInTime =
                                                        formatTime(
                                                          punchDetail.punch_in_time
                                                        );
                                                      const punchOutTime =
                                                        punchDetail.punch_out_time
                                                          ? punchDetail.punch_in_date !==
                                                            punchDetail.punch_out_date
                                                            ? `${dayjs(
                                                                punchDetail.punch_out_date
                                                              ).format(
                                                                "MMM-DD, YYYY"
                                                              )} ${formatTime(
                                                                punchDetail.punch_out_time
                                                              )}`
                                                            : formatTime(
                                                                punchDetail.punch_out_time
                                                              )
                                                          : "Pending";

                                                      return (
                                                        <span key={index}>
                                                          {punchInTime} -{" "}
                                                          {punchOutTime}
                                                          {index !==
                                                            att.punchDetails
                                                              .length -
                                                              1 && ", "}
                                                        </span>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <span> </span>
                                                )}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {att.break_hours === null ||
                                                att.total_hours === null ||
                                                isNaN(
                                                  parseFloat(
                                                    String(att.break_hours)
                                                  )
                                                ) ||
                                                isNaN(
                                                  parseFloat(
                                                    String(att.total_hours)
                                                  )
                                                )
                                                  ? ""
                                                  : parseFloat(
                                                      String(att.break_hours)
                                                    ) +
                                                      parseFloat(
                                                        String(att.total_hours)
                                                      ) ===
                                                    0
                                                  ? "-"
                                                  : `${(
                                                      parseFloat(
                                                        String(att.break_hours)
                                                      ) +
                                                      parseFloat(
                                                        String(att.total_hours)
                                                      )
                                                    ).toFixed(2)} hrs`}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {att.break_hours === null ||
                                                isNaN(
                                                  parseFloat(
                                                    String(att.break_hours)
                                                  )
                                                )
                                                  ? ""
                                                  : parseFloat(
                                                      String(att.break_hours)
                                                    ) === 0
                                                  ? "-"
                                                  : `${parseFloat(
                                                      String(att.break_hours)
                                                    ).toFixed(2)} hrs`}
                                              </TableCell>
                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {att.total_hours === null ||
                                                isNaN(
                                                  parseFloat(
                                                    String(att.total_hours)
                                                  )
                                                )
                                                  ? ""
                                                  : parseFloat(
                                                      String(att.total_hours)
                                                    ) === 0
                                                  ? "-"
                                                  : `${parseFloat(
                                                      String(att.total_hours)
                                                    ).toFixed(2)} hrs`}
                                              </TableCell>

                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {record.employee
                                                  .hourly_salary === null ||
                                                isNaN(
                                                  parseFloat(
                                                    String(
                                                      record.employee
                                                        .hourly_salary
                                                    )
                                                  )
                                                )
                                                  ? ""
                                                  : parseFloat(
                                                      String(
                                                        record.employee
                                                          .hourly_salary
                                                      )
                                                    ) === 0
                                                  ? "-"
                                                  : `$ ${parseFloat(
                                                      String(
                                                        record.employee
                                                          .hourly_salary
                                                      )
                                                    ).toFixed(2)}`}
                                              </TableCell>

                                              <TableCell
                                                scope="row"
                                                className={classes.tablCellId}
                                                sx={{ textAlign: "right" }}
                                              >
                                                {"$ "}
                                                {(
                                                  (Number(att.total_hours) ||
                                                    0) *
                                                  (Number(
                                                    record.employee
                                                      ?.hourly_salary
                                                  ) || 0)
                                                ).toFixed(2)}
                                              </TableCell>
                                            </TableRow>
                                          ))
                                        )}
                                        <TableRow
                                        // className={classes.tableRowHover}
                                        >
                                          <TableCell scope="row"></TableCell>
                                          <TableCell
                                            scope="row"
                                            // sx={{ textAlign: "center" }}
                                          ></TableCell>
                                          <TableCell
                                            scope="row"
                                            sx={{ textAlign: "right" }}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            ></Typography>
                                          </TableCell>
                                          <TableCell
                                            scope="row"
                                            sx={{ textAlign: "right" }}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            ></Typography>
                                          </TableCell>
                                          <TableCell
                                            scope="row"
                                            // className={classes.tablCellpx}
                                            sx={{ textAlign: "right" }}
                                          >
                                            {Number(
                                              record.employee
                                                .total_normal_hours || 0
                                            ).toFixed(2)}
                                            {" hrs"}
                                          </TableCell>
                                          <TableCell
                                            scope="row"
                                            sx={{ textAlign: "right" }}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            ></Typography>
                                          </TableCell>
                                          <TableCell
                                            scope="row"
                                            // className={classes.tablCellpx}
                                            sx={{ textAlign: "right" }}
                                          >
                                            {"$ "}
                                            {Number(
                                              Number(
                                                record.employee
                                                  .total_normal_hours || 0
                                              ) *
                                                Number(
                                                  record.employee
                                                    .hourly_salary || 0
                                                )
                                            ).toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </Grid>
                              )}
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2} sx={{ px: 2 }}>
                                  <Grid item lg={6} md={2} sm={2}></Grid>

                                  <Grid
                                    item
                                    lg={6}
                                    md={10}
                                    sm={10}
                                    xs={12}
                                    className={classes.cardGreenBAckGroundColor}
                                  >
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            lg={8}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            >
                                              Normal Working Amount (
                                              {Number(
                                                record.employee
                                                  .total_normal_hours || 0
                                              ).toFixed(2)}
                                              {" hrs * $"}
                                              {Number(
                                                record.employee.hourly_salary ||
                                                  0
                                              ).toFixed(2)}
                                              )
                                            </Typography>
                                          </Grid>

                                          <Grid
                                            item
                                            lg={4}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                              alignItems: "center",
                                            }}
                                            paddingRight={2}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            >
                                              {"$ "}
                                              {Number(
                                                Number(
                                                  record.employee
                                                    .total_normal_hours || 0
                                                ) *
                                                  Number(
                                                    record.employee
                                                      .hourly_salary || 0
                                                  )
                                              ).toFixed(2)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            lg={8}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            >
                                              OT Amount (
                                              {Number(
                                                record.employee
                                                  .total_ot_hours || 0
                                              ).toFixed(2)}
                                              {" hrs * $"}
                                              {Number(
                                                record.employee
                                                  .ot_hourly_salary || 0
                                              ).toFixed(2)}
                                              )
                                            </Typography>
                                          </Grid>

                                          <Grid
                                            item
                                            lg={4}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                              alignItems: "center",
                                            }}
                                            paddingRight={2}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            >
                                              {"$ "}
                                              {Number(
                                                Number(
                                                  record.employee
                                                    .total_ot_hours || 0
                                                ) *
                                                  Number(
                                                    record.employee
                                                      .ot_hourly_salary || 0
                                                  )
                                              ).toFixed(2)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            lg={8}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            >
                                              Adjustment Amount
                                            </Typography>
                                          </Grid>

                                          <Grid
                                            item
                                            lg={4}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                              alignItems: "center",
                                            }}
                                            paddingRight={2}
                                            pb={1}
                                            borderBottom={0.5}
                                          >
                                            <Typography
                                              className={
                                                classes.cardGreenTypograpy
                                              }
                                            >
                                              {"$ "}
                                              {Number(
                                                record.employee.bonus_amount ||
                                                  0
                                              ).toFixed(2)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        py={2}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            lg={8}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-start",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography className={classes.h4}>
                                              Total Amount
                                            </Typography>
                                          </Grid>

                                          <Grid
                                            item
                                            lg={4}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                              alignItems: "center",
                                            }}
                                            paddingRight={2}
                                          >
                                            <Typography className={classes.h4}>
                                              {"$ "}
                                              {Number(
                                                record.employee.total_salary ||
                                                  0
                                              ).toFixed(2)}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        );
                      }
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
